module.exports = __webpack_public_path__ + "media/images/flags/32/Brazil-6741a8783902b681d0a182f1a77e2a46.png";